<template>
    <v-dialog v-model="dialog" fullscreen hide-overlay transition="dialog-bottom-transition">
        <template v-slot:activator="{ on }">
            <v-btn color="primary" block v-on="on">
                <i class="material-icons"> my_location </i><v-spacer></v-spacer> Confirmar Punto
            </v-btn>
        </template>
        <v-card>
            <v-card-title>
                <app-sub-title>Escanee el código QR</app-sub-title>
            </v-card-title>
            <v-card-text>
                <qrcode-stream v-if="reading" @decode="onDecode"></qrcode-stream>
            </v-card-text>
            <v-card-actions>
                <v-btn color="error" block @click="dialog = false">Cancelar</v-btn>
            </v-card-actions>
        </v-card>
    </v-dialog>
</template>
<script>
import { QrcodeStream } from 'vue-qrcode-reader';
export default {
    components: {
        QrcodeStream,
    },
    data: () => ({
        dialog: false,
        reading: false
    }),
    watch: {
        dialog(val) {
            this.reading = val;
        }
    },
    methods: {
        onDecode(str) {
            const point = JSON.parse(str);
            this.$emit('decode', point);
        },
        close() {
            this.dialog = false;
        }
    }
}
</script>